import { KeyboardEvent } from 'react';

const HORIZONTAL_SCROLL_STEP_PX = 120;

// For a focusable region around a table whose sideways scroller takes no
// focus of its own. Modified arrows stay with the browser: Alt+Left and
// Cmd+Left go Back.
export const scrollHorizontallyByKey = (
  event: KeyboardEvent<HTMLElement>,
  viewport: HTMLElement | null
) => {
  if (
    !viewport ||
    event.target !== event.currentTarget ||
    event.altKey ||
    event.metaKey ||
    event.ctrlKey
  )
    return;

  const maxScroll = viewport.scrollWidth - viewport.clientWidth;
  if (maxScroll <= 0) return;

  const next = {
    ArrowRight: viewport.scrollLeft + HORIZONTAL_SCROLL_STEP_PX,
    ArrowLeft: viewport.scrollLeft - HORIZONTAL_SCROLL_STEP_PX,
    Home: 0,
    End: maxScroll
  }[event.key];
  if (next === undefined) return;

  event.preventDefault();
  viewport.scrollLeft = Math.max(0, Math.min(next, maxScroll));
};
